import React from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { SettingsProvider } from "utils/settingsContext";
import { FraudCheckProvider } from "utils/fraudCheckContext";
import queryClient from "api/queryClient";

/**
 * <PostAuthProviders /> contains providers we only want to surface after the widget has been
 * successfully authenticated in <AppAuth />
 */
export const PostAuthProviders = ({ children }) => {
  return (
    <QueryClientProvider client={queryClient}>
      <SettingsProvider>
        <FraudCheckProvider>{children}</FraudCheckProvider>
      </SettingsProvider>
    </QueryClientProvider>
  );
};
